<script>
  import ProjectListItem from './ProjectListItem.svelte';
 
  let {
    base_url,
    projects
  } = $props();

  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  const now = new Date();

</script>

<ol id="projects_list" class="list-unstyled m-0 p-0">
  {#each projects as proj}
  <ProjectListItem {base_url} {proj} {rtf} {now} />
  {/each}
</ol>

<div class="svg-sprites">
  <div class="fontawesome">
    <svg xmlns="http://www.w3.org/2000/svg">
      <symbol id="arrow-down-to-bracket" viewBox="0 0 448 512">
        <path d="m 246.6,342.625 c -12.5,12.5 -32.8,12.5 -45.3,0 l -128,-128 c -12.5,-12.5 -12.5,-32.8 0,-45.3 12.5,-12.5 32.8,-12.5 45.3,0 l 73.4,73.4 v -210.7 c 0,-17.7 14.3,-32 32,-32 17.7,0 32,14.3 32,32 v 210.7 l 73.4,-73.4 c 12.5,-12.5 32.8,-12.5 45.3,0 12.5,12.5 12.5,32.8 0,45.3 l -128,128 z M 64,352 C 64,334.3 49.7,320 32,320 14.3,320 0,334.3 0,352 v 64 c 0,53 43,96 96,96 h 256 c 53,0 96,-43 96,-96 v -64 c 0,-17.7 -14.3,-32 -32,-32 -17.7,0 -32,14.3 -32,32 v 64 c 0,17.7 -14.3,32 -32,32 H 96 C 78.3,448 64,433.7 64,416 Z"/>
      </symbol>
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg">
      <symbol id="arrows-rotate" viewBox="0 0 512 512">
        <path d="M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H352c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V432c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"/>
      </symbol>
    </svg>
  </div>
</div>
